"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Wordpress;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Wordpress(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 100,
    height: 100
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "WordPress"), /*#__PURE__*/_react["default"].createElement("g", {
    id: "Social_media",
    "data-name": "Social media"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    id: "wordpress",
    d: "M50,10A40,40,0,1,0,90,50,40.045,40.045,0,0,0,50,10ZM14.032,50a35.716,35.716,0,0,1,3.113-14.629l17.161,47A35.995,35.995,0,0,1,14.032,50ZM50,85.968A35.813,35.813,0,0,1,39.839,84.5l10.79-31.355,11.048,30.29a5,5,0,0,0,.258.5A35.985,35.985,0,0,1,50,85.968Zm4.952-52.823c2.161-.113,4.113-.339,4.113-.339a1.488,1.488,0,0,0-.226-2.967s-5.823.451-9.581.451c-3.532,0-9.468-.451-9.468-.451a1.488,1.488,0,0,0-.225,2.967s1.838.226,3.774.339l5.6,15.355-7.87,23.6-13.1-38.952c2.161-.113,4.113-.339,4.113-.339a1.488,1.488,0,0,0-.226-2.967s-5.823.451-9.581.451c-.677,0-1.468-.016-2.322-.048A35.966,35.966,0,0,1,74.29,23.468a4.581,4.581,0,0,0-.467-.033,6.225,6.225,0,0,0-6.033,6.388c0,2.967,1.71,5.467,3.533,8.435a18.875,18.875,0,0,1,2.967,9.919c0,3.081-1.177,6.646-2.742,11.629L67.968,71.79,54.952,33.145ZM68.081,81.081,79.065,49.323a34.025,34.025,0,0,0,2.741-12.888,26.517,26.517,0,0,0-.241-3.693A35.971,35.971,0,0,1,68.081,81.081Z"
  })));
}